module.exports = __webpack_public_path__ + "img/circle_num_1.b11e72a6.svg";